import React from 'react';

interface Props {
    phoneNumber?: string;
}

export const getFormattedPhoneNumber = (phoneNumber?: string)=> {
    if (!phoneNumber) return "";

    let areaCode = "";

    if(phoneNumber.length === 11) {
        areaCode = phoneNumber.slice(0,2);
    }

    const restOfPhoneNumber = areaCode ? phoneNumber.slice(2) : phoneNumber;
    const withSpaceEveryThreeDigits = restOfPhoneNumber.match(/.{1,3}/g)?.join(' ') || "";


    return `${areaCode ? "+" : ""}${areaCode}${areaCode ? " " : ""}${withSpaceEveryThreeDigits}`;
}

export const FormattedPhoneNumber = ({phoneNumber}: Props) => {
    if (!phoneNumber) return <></>;

	return (<>{getFormattedPhoneNumber(phoneNumber)}</>);
}